import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

export const subscriptionsMetadataAdapter = createEntityAdapter({
  selectId: (sub: API.CardSubscription) => sub.id,
});

const slice = createSlice({
  name: "subscriptionsMetadata",
  initialState: subscriptionsMetadataAdapter.getInitialState(),
  reducers: {
    setAll: subscriptionsMetadataAdapter.setAll,
    addMany: subscriptionsMetadataAdapter.addMany,
    removeAll: (state) => {
      subscriptionsMetadataAdapter.removeAll(state);
    },
  },
});

export const { actions: metadataActions } = slice;
export default {
  subscriptionsMetadata: slice.reducer,
};
